import React, { useEffect } from "react";
import {Form, Button, Alert, Col, Row, Card} from "react-bootstrap";
import {Formik, FormikProps} from "formik";
import { updateDonorDetails } from "./store/actions/DonorDetailsActions";
import { connect } from "react-redux";
import DonorDetails from "./store/actions/DonorDetails";
import { Redirect, withRouter } from "react-router-dom";
import Centre from "./models/Centre";
import * as Yup from "yup";
import { setCenter, setEventGroupName } from "./store/actions/UIStateActions";
import getCentersForEventGroup from "./EventGroupAllowedCenterMap";

export interface DonorDetailsProps {
    donor: DonorDetails;
    uiState: any;
    updateDonorDetails: (donorDetails: DonorDetails) => void;
    match: any;
    updateEventGroupName: (eventGroupName: string) => void;
    setCenter: (centerId: number) => void;
    acquireAddress? : boolean;
}

interface BKTShirtsOrderFormProps {
    firstName: string;
    middleName: string;
    lastName: string;
    email: string;
    mobileNumber: string;
    centre: number;
    centerSetInUiState: boolean;
    address: string | undefined;
    suburb: string | undefined;
    zip: number | undefined;
    group: string | undefined
}

interface CustomAttributeDefinition { 
    attributeName: string;
    label: string;
}


function AcquireDonorDetails(props: DonorDetailsProps) {

    const [donorDetailsEntered, setDonorDetailEntered] = React.useState<boolean>(false);

    useEffect(() => {
        const eventGroupName: string = "bk-sports-day-t-shirts";

        props.updateEventGroupName(eventGroupName);

    }, []);

    const convertCenterToNumber = (centerName: string): number => {

        switch (centerName) {
            case "sydney": return Centre.Sydney;
            case "adelaide": return Centre.Adelaide;
            case "brisbane": return Centre.Brisbane;
            case "canberra": return Centre.Canberra;
            case "darwin": return Centre.Darwin;
            case "goldCoast": return Centre.GoldCoast;
            case "melbournemandir": return Centre.MelbourneMandir;
            case "melbournewest": return Centre.MelbourneMandir;
            case "melbournesouth": return Centre.MelbourneMandir;
            case "perth": return Centre.Perth;
            case "hobart": return Centre.Hobart;
            case "sydney": return Centre.Sydney;
            case "griffith": return Centre.Griffith;
        }

        return -1;
    }

    const defaultFormValues: BKTShirtsOrderFormProps = {
        firstName: props.donor.firstName,
        middleName: "",
        lastName: props.donor.lastName,
        mobileNumber: props.donor.mobile,
        email: props.donor.email,
        centre: props.donor.centre,
        centerSetInUiState: props.uiState.center !== null,
        address: undefined,
        suburb: undefined,
        zip: undefined,
        group: undefined
    }

    console.log(defaultFormValues);

    const donorDetailsSchema = Yup.object().shape({
        firstName: Yup.string().required().max(50),
        middleName: Yup.string().required().max(50),
        lastName: Yup.string().required().max(50),
        mobileNumber: Yup.string().matches(/(0|\+\d{1,3})[0-9]{8,10}\b/gm, "Please enter mobile number in 04xxxxxxxx (AU)/ 02XXXXXXXXX / +1567890123").required(),
        email: Yup.string().email().required(),
        centerSetInUiState: Yup.boolean(),
        centre: Yup.number().when("centerSetInUiState", {
            is: false,
            then: Yup.number().required().min(1, "Center is required before submission")
        }),
        suburb: Yup.string().max(100),
        address: Yup.string().max(500),
        zip: Yup.number().max(9999),
        group: Yup.string().required().max(100),
    });

    const onNextClick = (values: BKTShirtsOrderFormProps) => {

    const firstName = `${values.firstName.trim()} ${values.middleName.trim()}`;

        props.updateDonorDetails({
            firstName: firstName,
            lastName: values.lastName,
            email: values.email,
            mobile: values.mobileNumber,
            centre: props.uiState.center !== null ? props.uiState.center : values.centre,
            address: values.address,
            suburb: values.suburb,
            zip: values.zip,
            customAttributes: { Group: values.group! }
        });

        setDonorDetailEntered(true);
    }

    const renderCentreSelect = (): Array<JSX.Element> => {
        const allowedCenters = getCentersForEventGroup("bk-sports-day-t-shirts");
        const optionsForCentres = new Array<JSX.Element>();

        allowedCenters.forEach(eachCenter => {
            const keyNumeric: number = eachCenter;

            if (isNaN(keyNumeric))
                return;

            optionsForCentres.push(<option key={`Centre-${keyNumeric}`} value={keyNumeric}>{Centre[keyNumeric]}</option>)
        });

        return optionsForCentres;
    }

    const renderForm = (formikProps: FormikProps<BKTShirtsOrderFormProps>) => {

        return (<Form onSubmit={formikProps.handleSubmit}>
            <Form.Group controlId="formFirstName">
                <Form.Label>First Name</Form.Label>
                <Form.Control type="text"
                    placeholder="Enter first name"
                    onChange={formikProps.handleChange}
                    value={formikProps.values.firstName}
                    name="firstName" />
                <Form.Text className="text-muted">
                    Please enter your first name.
                </Form.Text>
                {formikProps.touched &&
                    formikProps.touched.firstName &&
                    formikProps.errors.firstName ?
                    (<div className="fade alert alert-danger show">{formikProps.errors.firstName}</div>) : (<React.Fragment />)}
            </Form.Group>

            <Form.Group controlId="formMiddleName">
                <Form.Label>Middle Name</Form.Label>
                <Form.Control type="text"
                    placeholder="Enter middle name"
                    name="middleName"
                    onChange={formikProps.handleChange}
                    value={formikProps.values.middleName} />
                <Form.Text className="text-muted">
                    Please enter your middle name.
                </Form.Text>
                {formikProps.touched &&
                    formikProps.touched.middleName &&
                    formikProps.errors.middleName ?
                    (<div className="fade alert alert-danger show">{formikProps.errors.middleName}</div>) : (<React.Fragment />)}
            </Form.Group>

            <Form.Group controlId="formEmail">
                <Form.Label>Last Name</Form.Label>
                <Form.Control type="text"
                    placeholder="Enter last name"
                    name="lastName"
                    onChange={formikProps.handleChange}
                    value={formikProps.values.lastName} />
                <Form.Text className="text-muted">
                    Please enter your last name.
                </Form.Text>
                {formikProps.touched &&
                    formikProps.touched.lastName &&
                    formikProps.errors.lastName ?
                    (<div className="fade alert alert-danger show">{formikProps.errors.lastName}</div>) : (<React.Fragment />)}
            </Form.Group>

            <Form.Group controlId="formGroup">
                <Form.Label>Group</Form.Label>
                <Form.Control as="select" onChange={formikProps.handleChange} value={formikProps.values.group} name="group">
                    <option value="">Select Group</option>
                    <option value="Balak">Balak</option>
                    <option value="Balika">Balika</option>
                    <option value="Kishore">Kishore</option>
                    <option value="Kishori">Kishori</option>
                </Form.Control>
                <Form.Text className="text-muted">
                    Please select your group.
                </Form.Text>
                {formikProps.touched &&
                    formikProps.touched.group &&
                    formikProps.errors.group ?
                    (<div className="fade alert alert-danger show">{formikProps.errors.group}</div>) : (<React.Fragment />)}
            </Form.Group>

            <Form.Group controlId="formEmail">
                <Form.Label>Email address</Form.Label>
                <Form.Control type="email"
                    placeholder="Enter email"
                    name="email"
                    value={formikProps.values.email}
                    onChange={formikProps.handleChange} />
                <Form.Text className="text-muted">
                    Please enter your email id. Receipt will be sent to the email id entered here.
                </Form.Text>
                {formikProps.touched &&
                    formikProps.touched.email &&
                    formikProps.errors.email ?
                    (<div className="fade alert alert-danger show">{formikProps.errors.email}</div>) : (<React.Fragment />)}
            </Form.Group>

            <Form.Group controlId="formMobile">
                <Form.Label>Mobile number</Form.Label>
                <Form.Control type="text"
                    placeholder="04XXXXXXXX(AU)/02XXXXXXXXX(NZ)/+1XXXXXXXXXX"
                    name="mobileNumber"
                    onChange={formikProps.handleChange} />
                <Form.Text className="text-muted">
                    Please enter your mobile number starting with 04 (AU) / 02 (NZ) / (+CountryCode) Mobile Number.
                </Form.Text>
                {formikProps.touched &&
                    formikProps.touched.mobileNumber &&
                    formikProps.errors.mobileNumber ?
                    (<div className="fade alert alert-danger show">{formikProps.errors.mobileNumber}</div>) : (<React.Fragment />)}
            </Form.Group>

            {props.uiState.center === null ? <Form.Group controlId="formMobile">
                <Form.Label>Select Centre</Form.Label>
                <Form.Control as="select"
                    name="centre"
                    onChange={formikProps.handleChange} >
                    <option></option>
                    {renderCentreSelect()}
                </Form.Control>
                <Form.Text className="text-muted">
                    Please select the centre Or International if your are outside ANZ.
                </Form.Text>
                {formikProps.touched &&
                    formikProps.touched.centre &&
                    formikProps.errors.centre ?
                    (<div className="fade alert alert-danger show">{formikProps.errors.centre}</div>) : (<React.Fragment />)}
            </Form.Group> : <React.Fragment />}

            <Button variant="primary" type="submit" size="lg">
                NEXT
            </Button>
        </Form>);
    }

    const renderDonorDetailsForm = () => {
        return (<Formik
            enableReinitialize={true}
            initialValues={defaultFormValues}
            onSubmit={onNextClick}
            render={renderForm}
            validationSchema={donorDetailsSchema}
        />);
    }

    const redirectToDonationDetails = () => {
        return (<Redirect to="/donation-details" />)
    }

    return (
        <div>
            {donorDetailsEntered ? redirectToDonationDetails() : renderDonorDetailsForm()}
        </div>
    );
}

const mapStateToProps = (state: any) => {
    return {
        donor: state.donor,
        uiState: state.uiState
    };
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        updateDonorDetails: (donorDetails: DonorDetails) => dispatch(updateDonorDetails(donorDetails)),
        updateEventGroupName: (eventGroupName: string) => dispatch(setEventGroupName(eventGroupName)),
        setCenter: (center: number) => dispatch(setCenter(center)),
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AcquireDonorDetails));
